import React, { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import AddBookings from './AddBookings';
import CircularLoading from '../components/CircularLoading';
import { getPartnerDisplayName, isPartnerComingSoon, isPartnerMaintenance, resolvePartnerConfig, resolvePartnerFromHost } from '../common/partnerUtils';
import PartnerUpsellPage from './PartnerUpsellPage';
import PartnerMaintenancePage from './PartnerMaintenancePage';
import PartnerComingSoonPage from './PartnerComingSoonPage';
import PartnerMeta from '../components/PartnerMeta.jsx';

export default function PartnerBookingPage() {
  const { partnerSlug } = useParams();
  const settings = useSelector(state => state.settingsdata.settings);
  const auth = useSelector(state => state.auth);
  const isAdmin = auth?.profile?.usertype === 'admin' || auth?.profile?.usertype === 'fleetadmin';
  const partner = useMemo(() => {
    if (partnerSlug) {
      return resolvePartnerConfig(settings, partnerSlug);
    }
    if (typeof window !== 'undefined') {
      return resolvePartnerFromHost(settings, window.location.hostname);
    }
    return null;
  }, [settings, partnerSlug]);

  if (!settings) {
    return <CircularLoading />;
  }

  if (!partner) {
    return (
      <div style={{ padding: 32 }}>
        <h2>Partner page not found</h2>
        <p>Please check the URL or contact the business.</p>
      </div>
    );
  }

  if (isPartnerComingSoon(partner) && !isAdmin) {
    return <PartnerComingSoonPage partner={partner} />;
  }

  if (isPartnerMaintenance(partner) && !isAdmin) {
    return <PartnerMaintenancePage partner={partner} />;
  }

  if (partner.inactive) {
    return <PartnerUpsellPage partner={partner} />;
  }

  const partnerName = getPartnerDisplayName(partner, settings) || 'Partner';

  return (
    <>
      <PartnerMeta partner={partner} title={`Book with ${partnerName}`} />
      <AddBookings partner={partner} />
    </>
  );
}
